define(function(require) {
  var IpsModel = require('civicsBase/ipsModel');
  
  return IpsModel.extend({
    urlRoot: '/delegate/civics-api/api/portal/search',

    url: function() {
      let url = this.urlRoot;

      if (this.isNew()) {
        url += '/add';
      } else {
        url += '/' + this.id;
      }

      return url;
    },
  });
});

